import { createFileRoute } from '@tanstack/react-router';

import PendingApproval from '@/pages/PendingApproval';

export const Route = createFileRoute('/_app/pending-approval')({
  component: PendingApproval,
});
